import { useModelsByAssetQuery } from 'queries/notifications/queries';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormSelect } from 'ui/FormComponents';

const AssetModelsSelect = ({ assetId }: { assetId?: string }) => {
  const { setValue } = useFormContext();
  const { data, isLoading } = useModelsByAssetQuery(assetId);
  const { t } = useTranslation();
  const placeholderText = assetId
    ? t('components:ConditionDeviation.placeholders.selectAnOption')
    : t(`components:notifications.form.placeholders.modelWithoutAsset`);

  const placeHolderOption = {
    value: placeholderText,
    label:
      data?.length === 0
        ? t(`components:notifications.form.placeholders.withoutModel`)
        : placeholderText,
    disabled: true,
  };
  useEffect(() => {
    setValue('model_id', undefined);
  }, [assetId]);
  return (
    <FormSelect
      key="model"
      name="model_id"
      label={t(`components:notifications.form.labels.model`)}
      placeHolderText={placeHolderOption.label}
      selectOptionData={data ?? []}
      isRequired
      disabled={isLoading || data?.length === 0}
    />
  );
};

export default AssetModelsSelect;
